<script>
  import { link } from "svelte-navigator";
  import { navigate } from "svelte-navigator";
  import { formData } from "../stores/formData.js";
  import { onMount, onDestroy } from "svelte";
  let open = false;
  let width = window.innerWidth;

  const resizeHandler = () => {
    width = window.innerWidth;
  };

  onMount(() => {
    window.addEventListener("resize", resizeHandler);
  });

  onDestroy(() => {
    window.removeEventListener("resize", resizeHandler);
  });

  function resetForm() {
    // empty store "formData"
    formData.update(() => ({
      id: "",
      name: "",
      date: "",
      time: "",
      location: "",
      isSet: false,
      isInitiated: false,
      reset: false,
    }));
    navigate("/");
  }
  function editForm() {
    $formData = { ...$formData, isInitiated: false };
    navigate("/");
  }
</script>

<div class="reset not-print">
  <button
    class="resetbtn"
    title="De huidige horoscoop aanpassen"
    on:click|preventDefault={editForm}>aanpassen horoscoop</button
  >
  -
  <button
    class="resetbtn"
    title="Start een nieuwe horoscoop met een leeg formulier"
    on:click|preventDefault={resetForm}>nieuwe horoscoop</button
  >
</div>

{#if width > 620}
  <!-- standard menu -->
  <div class="desktop-navigation navbar not-print">
    <div>
      <a href="/horoscope" use:link>Horoscoop</a>
    </div>
    <div>
      <a href="/aspects" use:link>Aspecten</a>
    </div>
    <div class="dropdown">
      <button class="dropbtn">Transits ▼</button>
      <div class="dropdown-content">
        <a href="/transitsCurrent" use:link>Huidige Transits</a>
        <a href="/transits" use:link>Lijst Transits</a>
      </div>
    </div>
    <div class="dropdown">
      <button class="dropbtn">Progressies ▼</button>
      <div class="dropdown-content">
        <a href="/progressionsCurrent" use:link>Huidige Progressies</a>
        <a href="/progressions" use:link>Lijst Progressies</a>
      </div>
    </div>
    <div class="dropdown">
      <button class="dropbtn">Midpunten ▼</button>
      <div class="dropdown-content">
        <a href="/midpointsPlanet" use:link>MP per planeet</a>
        <a href="/midpointsSign" use:link>MP per teken</a>
        <a href="/midpointsTree" use:link>MP boompjes</a>
      </div>
    </div>
    <div>
      <a href="/mirror-points" use:link>Spiegelpunten</a>
    </div>
  </div>
{:else}
  <!-- mobile menu -->
  <div class="mobile-navigation navbar not-print">
    <div class="navbar-header">
      <button class="hamburger" on:click={() => (open = !open)}>
        {open ? "✖" : "☰"}
      </button>
      <h2>Navigatie Menu</h2>
    </div>
    {#if open}
      <div class="menu">
        <a href="/horoscope" use:link>Horoscoop</a>
        <a href="/aspects" use:link>Aspecten</a>
        <a href="/transitsCurrent" use:link>Huidige Transits</a>
        <a href="/transits" use:link>Lijst Transits</a>
        <a href="/progressionsCurrent" use:link>Huidige Progressies</a>
        <a href="/progressions" use:link>Lijst Progressies</a>
        <a href="/midpointsPlanet" use:link>MP per planeet</a>
        <a href="/midpointsSign" use:link>MP per teken</a>
        <a href="/midpointsTree" use:link>MP boompjes</a>
        <a href="/mirror-points" use:link>Spiegelpunten</a>
      </div>
    {/if}
  </div>
{/if}

<style>
  .navbar,
  .mobile-navigation {
    position: relative;
    display: flex;
    align-items: center;
    background-color: #333;
    font-family: Arial;
    color: white;
    padding-left: 8px;
  }

  .navbar {
    height: 55px;
    border-radius: 5px;
  }

  .navbar a,
  .desktop-navigation .dropdown .dropbtn,
  .mobile-navigation {
    font-size: 10px;
    color: white;
    text-decoration: none;
    padding: 1rem;
    transition: background-color 0.3s ease;
    border-radius: 3px;
  }

  .menu a {
    font-size: 14px;
    color: white;
    text-decoration: none;
    padding: 1rem;
    transition: background-color 0.3s ease;
    border-radius: 3px;
  }

  .desktop-navigation .dropdown,
  .dropdown {
    position: relative;
    border-radius: 3px;
  }

  .desktop-navigation .dropdown-content,
  .dropdown-content {
    position: absolute;
    top: 100%;
    left: 0;
    display: none;
    z-index: 1;
    min-width: 100px;
    max-width: 300px;
    width: fit-content;
    padding: 1rem 0;
    background-color: #f9f9f9;
    box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.2);
    border-radius: 0 0 5px 5px;
  }

  .dropdown:hover .dropdown-content,
  .desktop-navigation .dropdown:hover .dropdown-content {
    display: block;
  }

  .desktop-navigation .navbar a,
  .desktop-navigation .dropdown .dropbtn,
  .navbar a,
  .dropdown .dropbtn {
    display: flex;
    align-items: center;
  }

  .mobile-navigation {
    flex-direction: column;
  }

  .mobile-navigation .hamburger {
    font-size: 24px;
    background: none;
    border: none;
    color: #fff;
    margin: 0;
  }

  .mobile-navigation h2 {
    color: #fff;
    margin-left: 10px;
  }

  .mobile-navigation .menu {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8); /* semi-translucent black */
    z-index: 5; /* "stack" the menu above the page content */
  }

  .mobile-navigation .menu a:hover,
  .navbar a:hover,
  .dropdown:hover .dropbtn {
    background-color: darkgreen;
  }

  @media (max-width: 620px) {
    .desktop-navigation {
      display: none; /* Hide desktop navigation */
    }

    .mobile-navigation {
      display: block; /* Show mobile navigation */
    }
  }

  @media (min-width: 620px) {
    .mobile-navigation {
      display: none;
    }
  }

  .dropdown-content a {
    display: block;
    font-size: 12px;
    color: black;
    padding: 0.5rem 1rem;
    text-decoration: none;
    transition: background-color 0.3s ease;
    white-space: nowrap;
  }

  .dropdown-content a:hover {
    background-color: #ddd;
  }

  .mobile-navigation .navbar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px; /* Adjust as needed */
    padding-left: 0;
    color: white;
  }

  .dropbtn {
    background-color: #333;
    border: none;
    margin: 0;
  }
  .reset {
    font-size: smaller;
  }

  .resetbtn {
    background-color: transparent; /* no color */
    border: 1px solid #d3d0d0; /* subtle border */
    color: black;
    padding: 5px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 11px;
    margin-top: 0px;
    margin-bottom: 5px;
    cursor: pointer;
    border-radius: 5px;
    transition: background-color 0.3s ease; /* smooth color transition */
  }

  .resetbtn:hover {
    background-color: #d3d0d0; /* background color on hover */
  }
</style>
